import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

function MobileMenu({ isOpen, onClose, categories, destination }) {
  const [activeMenu, setActiveMenu] = useState(null);
  const menuRefs = useRef({});
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = (index) => {
    setActiveMenu(activeMenu === index ? null : index);
  };

  // Scroll height animation
  useEffect(() => {
    Object.keys(menuRefs.current).forEach((key) => {
      const submenu = menuRefs.current[key];
      if (submenu) {
        submenu.style.height =
          activeMenu == key ? `${submenu.scrollHeight}px` : "0px";
      }
    });
  }, [activeMenu]);

  // Gallery scroll handler
  const handleScrollClick = (section) => {
    onClose();

    if (location.pathname === "/") {
      scroller.scrollTo(section, {
        smooth: true,
        duration: 600,
        offset: -80,
      });
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };

  return (
    <div
      className={`th-menu-wrapper onepage-nav ${
        isOpen ? "th-body-visible" : ""
      }`}
      style={{ visibility: isOpen ? "visible" : "hidden" }}
    >
      <div className="th-menu-area text-center">
        <button className="th-menu-toggle" onClick={onClose}>
          <i className="fal fa-times" />
        </button>

        <div className="mobile-logo">
          <Link to="/" onClick={onClose}>
            <img src="/assets/img/logo1.png" alt="Mahakal Yatra" width={240} />
          </Link>
        </div>

        <div className="th-mobile-menu">
          <ul>
            {/* Home */}
            <li>
              <Link to="/" onClick={onClose}>
                Home
              </Link>
            </li>

            {/* About */}
            <li>
              <Link to="/about" onClick={onClose}>
                About Us
              </Link>
            </li>

            {/* Destination */}
            <li
              className={`menu-item-has-children ${
                activeMenu === 1 ? "th-active" : ""
              }`}
            >
              <Link to="#" onClick={() => toggleMenu(1)}>
                Destination
              </Link>

              <ul
                ref={(el) => (menuRefs.current[1] = el)}
                className="th-submenu"
                style={{
                  height: "0px",
                  overflow: "hidden",
                  transition: "height 0.3s ease-in-out",
                }}
              >
                {destination?.map((des) => (
                  <li key={des.id}>
                    <Link
                      to={`/destination/${des.id}`}
                      onClick={onClose}
                    >
                      {des.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            {/* Service */}
            <li
              className={`menu-item-has-children ${
                activeMenu === 2 ? "th-active" : ""
              }`}
            >
              <Link to="#" onClick={() => toggleMenu(2)}>
                Service
              </Link>

              <ul
                ref={(el) => (menuRefs.current[2] = el)}
                className="th-submenu"
                style={{
                  height: "0px",
                  overflow: "hidden",
                  transition: "height 0.3s ease-in-out",
                }}
              >
                {categories?.map((category) => (
                  <li key={category.id}>
                    <Link
                      to={`/service/${category.id}`}
                      onClick={onClose}
                    >
                      {category.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            {/* Gallery Scroll */}
            <li>
              <button
                onClick={() => handleScrollClick("gallery")}
                style={{
                  background: "none",
                  border: "none",
                  width: "100%",
                  textAlign: "left",
                  padding: "10px 0",
                }}
              >
                Gallery
              </button>
            </li>

            {/* Contact */}
            <li>
              <Link to="/contact" onClick={onClose}>
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default MobileMenu;